import React from 'react'
// hooks
import { useShowModal } from 'hooks/useShowModal'
// components
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'
import AccordionOrigin from '@mui/material/Accordion'
import AccordionDetails from '@mui/material/AccordionDetails'
import AccordionSummary from '@mui/material/AccordionSummary'
import { ReduxInput, ReduxSelect } from 'components/FormElements/ReduxForm'
import { Button, BUTTON_LAYOUTS, CREATE_BUTTON_STYLE } from 'components/UI'
// constants
import { Modals } from 'constants/modals'
import { PANEL_STYLES } from '../UserData'
import { AUTH_METHOD_OPTIONS } from 'constants/users'
// themes
import { colors } from 'themes/index'
// views
import { FieldsContainer } from '../OrganizationData/views'
// utils
import { required } from 'utils/validators'

const BTN_STYLE = { marginTop: 20 }

const SecurityData: React.FC = () => {
  const { showModal: showChangePasswordModal } = useShowModal({ modalType: Modals.CHANGE_USER_PASSWORD_MODAL })

  const onChangePasswordClick = () => showChangePasswordModal()

  return (
    <AccordionOrigin>
      <AccordionSummary expandIcon={<ExpandMoreIcon htmlColor={colors.blue500} />}>Security data</AccordionSummary>
      <AccordionDetails style={PANEL_STYLES}>
        <FieldsContainer>
          <ReduxInput label='Username' name='username' validate={[required]} />
          <ReduxSelect
            label='Authentication Method'
            name='authMethod'
            options={AUTH_METHOD_OPTIONS}
            validate={required}
            menuPlacement={'top'}
          />
        </FieldsContainer>

        <Button
          layout={BUTTON_LAYOUTS.PURPLE}
          onClick={onChangePasswordClick}
          style={{ ...CREATE_BUTTON_STYLE, ...BTN_STYLE }}>
          Change Password
        </Button>
      </AccordionDetails>
    </AccordionOrigin>
  )
}

export default SecurityData
